import './dpcatering/style';
import FormStructure from './dpcatering/form_structure';

export default FormStructure;